
const tgBot = {
    username: process.env.REACT_APP_TELEGRAM_BOT_USERNAME || 'bloodnexus_bot'
};

export default tgBot;